/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {InfoChartDataModel} from '../../../../shared/info-chart/models/info-chart-data.model';
import {BundlePositionsDetailModel} from '../../../models/bundle/bundle-positions-detail/bundle-positions-detail.model';
import {BundleTypeEnum} from '../../../bundles-main-page/data/bundle-type.enum';


export class BundleInformationTableInfoChartDataMapper {

    private constructor() {
    }

    static fromSettlementPositionBaseContractToInfoChartDataModelArray(input: BundlePositionsDetailModel[], bundleType: BundleTypeEnum):
            InfoChartDataModel<number>[] {
        return input?.map((element) => BundleInformationTableInfoChartDataMapper
                .fromBundlePositionsDetailModelToInfoChartDataModel(element, bundleType));
    }

    static getDescription(bundleType: BundleTypeEnum, input: BundlePositionsDetailModel): string {
        return bundleType === BundleTypeEnum.TE_MINUTES_BUNDLING ? 'Line 1'
                : input?.criteria?.map((item) => `${item.specCode} ${item.value}`)[0];
    }

    static fromBundlePositionsDetailModelToInfoChartDataModel(input: BundlePositionsDetailModel, bundleType: BundleTypeEnum):
            InfoChartDataModel<number> {

        let model: InfoChartDataModel<number>;
        if (input != null) {
            model = {
                identifier: input.position,
                status: 'BUNDLE',
                value: input.totalValue,
                description: BundleInformationTableInfoChartDataMapper.getDescription(bundleType, input)
            };
        }
        return model;
    }
}

